export enum Constants {
    GET_RESOURCE_TREE_ROOT,
    GET_RESOURCE_TREE_ROOT_FINISH,
    CREATE,
    CREATE_FINISH,
    DELETE,
    UPLOAD_DATA,
    UPLOAD_DATA_FINISH,
    GET_DATA,
    GET_DATA_FINISH,
    LOAD_FROM_FILE,
    LOAD_FROM_FILE_FINISH,
    GET_DIR_CONTENT,
    GET_DIR_CONTENT_FINISH,
    RESOURCE_RENAME_START,
    RESOURCE_RENAME_FINISH,
    RESOURCE_MOVE_START,
    RESOURCE_MOVE_FINISH,
    RESOURCE_COPY_START,
    SET_RESOURCE_SELECTED,
    ZERO_FLAGS
}
